class Building {
	id = null;
	code = '';
	street_and_no = '';
	postal_code = '';
	city = '';
	country = 'Hrvatska';
	active = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = '';
			}
		}
	}
}

export default Building;
